import React from 'react';

import BlokEditorDropDownItem from './BlokEditorDropDownItemEnum';
import TabRow from '../TabRow';

import Appearance from './Appearance';
import Properties from './Properties';
import Movement from './Movement';
import Rotation from './Rotation';
import GrowthShrinkage from './GrowthShrinkage';
import StaysDifferent from './StaysDifferent';
import settings from '../../../../settings';

export default function BlokEditorItems({ blokEditor, changeState, setOpenDropdownItem, updateShape, updateBlokStateSettings, updateBlokStateLook, assetHistory }) {
    return (
        <div>
            <TabRow
                activeItem={blokEditor.openDropdownItem}
                items={[
                    {
                        id: BlokEditorDropDownItem.APPEARANCE,
                        title: 'Uiterlijk',
                        icon: `${settings.assetsPath}img/icons/uiterlijk.png`,
                        iconStyle: { width: '34px', height: '25px', marginBottom: '2px' },
                        onClick: id => setOpenDropdownItem(id),
                        component: (
                            <Appearance
                                shape={blokEditor.shape}
                                type={blokEditor.type}
                                data={blokEditor.data}
                                updateShape={updateShape}
                                updateBlokStateLook={updateBlokStateLook}
                                changeState={changeState}
                                assetHistory={assetHistory}
                            />
                        )
                    },
                    {
                        id: BlokEditorDropDownItem.PROPERTIES,
                        title: 'Kenmerk',
                        icon: `${settings.assetsPath}img/icons/eigenschappen.png`,
                        iconStyle: { width: '27px', height: '26px', marginBottom: '1px' },
                        onClick: id => setOpenDropdownItem(id),
                        component: (
                            <Properties
                                updateBlokStateSettings={updateBlokStateSettings}
                                thingsMoveThroughMe={blokEditor.thingsMoveThroughMe}
                                friction={blokEditor.friction}
                                bounce={blokEditor.bounce}
                                weight={blokEditor.weight}
                            />
                        )
                    }
                ]}
            />
            <TabRow
                activeItem={blokEditor.openDropdownItem}
                items={[
                    {
                        id: BlokEditorDropDownItem.MOVEMENT,
                        title: 'Beweging',
                        icon: `${settings.assetsPath}img/icons/beweging.png`,
                        iconStyle: { width: '71px', height: '20px', marginBottom: '7px' },
                        onClick: id => setOpenDropdownItem(id),
                        component: <Movement updateBlokStateSettings={updateBlokStateSettings} movementBehaviour={blokEditor.movementBehaviour} speed={blokEditor.speed} />
                    },
                    {
                        id: BlokEditorDropDownItem.ROTATION,
                        title: 'Draaiing',
                        icon: `${settings.assetsPath}img/icons/draaing.png`,
                        iconStyle: { width: '28px', height: '27px' },
                        onClick: id => setOpenDropdownItem(id),
                        component: (
                            <Rotation
                                updateBlokStateSettings={updateBlokStateSettings}
                                rotationBehaviour={blokEditor.rotationBehaviour}
                                rotationSpeed={blokEditor.rotationSpeed}
                                rotationAngle={blokEditor.rotationAngle}
                                rotationDirection={blokEditor.rotationDirection}
                            />
                        )
                    }
                ]}
            />
            <TabRow
                activeItem={blokEditor.openDropdownItem}
                items={[
                    {
                        id: BlokEditorDropDownItem.GROWTH_SHRINKAGE,
                        title: 'Groei/krimp',
                        icon: `${settings.assetsPath}img/icons/groei.png`,
                        iconStyle: { width: '38px', height: '35px' },
                        onClick: id => setOpenDropdownItem(id),
                        component: (
                            <GrowthShrinkage
                                updateBlokStateSettings={updateBlokStateSettings}
                                resizeBehaviour={blokEditor.resizeBehaviour}
                                resizeSpeed={blokEditor.resizeSpeed}
                                resizeWidth={blokEditor.resizeWidth}
                                resizeHeight={blokEditor.resizeHeight}
                            />
                        )
                    },
                    changeState
                        ? {
                              id: BlokEditorDropDownItem.STAYS_DIFFERENT,
                              title: 'Daarna?',
                              icon: `${settings.assetsPath}img/icons/obj_pijl.png`,
                              iconStyle: { width: '35px', height: '35px' },
                              onClick: id => setOpenDropdownItem(id),
                              component: <StaysDifferent updateBlokStateSettings={updateBlokStateSettings} changesBack={blokEditor.changesBack} changeBackTime={blokEditor.changeBackTime} />
                          }
                        : null
                ]}
            />
        </div>
    );
}
